import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FroalaModule } from '@component/froala-editor';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';

import { MessageCommunicationTypesModule } from '@component/message-communication-types';

import { MessageInputComponent } from './message-input.component';

@NgModule({
  declarations: [MessageInputComponent],
  exports: [MessageInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    FroalaModule,
    InlineSVGModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MessageCommunicationTypesModule
  ]
})
export class MessageInputModule {}
